const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { saveLastVisitedVisualization } from '@/features/visualizations/utils/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/table/')({
  loader: ({
    params
  }) => saveLastVisitedVisualization(Number(params.viewId), 'table'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});